import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SessionActions } from '@ralba/core';
import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';
import { map, tap } from 'rxjs/operators';

import { TranslocoLocaleService } from '@ngneat/transloco-locale';

declare let require: any;

@Injectable()
export class CoreEffects {
  setSFLocalization$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SessionActions.getAllLoadded),
        map(({ localization }) => localization),
        tap(({ currentCulture, values }) => {
          // NOTE: Add here new culture in case
          const SyncfusionCulture = currentCulture.name == 'cs-CZ' ? 'cs' : currentCulture.name;

          console.log("Setting culture '" + currentCulture.name + "', for Syncfusion " + SyncfusionCulture)

          this.transloco.setActiveLang(currentCulture.name);
          setCulture(SyncfusionCulture);
          this.service.setLocale(currentCulture.name);

          // NOTE: fill syncfusion translations
          let syncfusionTranslation = {};
          for (const [key, value] of Object.entries(values["Syncfusion"])) {
            const keys = key.split(".");

            if (keys.length !== 2) {
              console.error("Unsupported syncfusion key " + key);
            }

            syncfusionTranslation = {
              ...syncfusionTranslation,
              [keys[0]]: {
                ...syncfusionTranslation[keys[0]],
                [keys[1]]: value
              }
            }
          }

          L10n.load({ [SyncfusionCulture]: syncfusionTranslation });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private transloco: TranslocoService,
    private service: TranslocoLocaleService
  ) {
    loadCldr(
      require('cldr-data/main/cs/numbers.json'),
      require('cldr-data/main/cs/ca-gregorian.json'),
      require('cldr-data/main/cs/dateFields.json'),
      require('cldr-data/main/cs/delimiters.json'),
      require('cldr-data/main/cs/localeDisplayNames.json'),
      require('cldr-data/supplemental/numberingSystems.json'),
      require('cldr-data/main/cs/timeZoneNames.json'),
      require('cldr-data/supplemental/weekData.json'),

      // NOTE: Add here new culture in case
      // require('cldr-data/main/es/numbers.json'),
      // require('cldr-data/main/es/ca-gregorian.json'),
      // require('cldr-data/main/es/dateFields.json'),
      // require('cldr-data/main/es/delimiters.json'),
      // require('cldr-data/main/es/localeDisplayNames.json'),
      // require('cldr-data/main/es/timeZoneNames.json'),

    );
  }
}
